var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unclaimedPro.account_claimed)?_c('Claimed',{attrs:{"pro":_vm.unclaimedPro}}):_c('Unclaimed',{attrs:{"pro":_vm.unclaimedPro}})}
var staticRenderFns = []

export { render, staticRenderFns }